import Icon from '@/components/ui/AppIcon';

interface ContentSection {
  id: string;
  title: string;
  content: string;
  icon: string;
}

interface EducationalContentProps {
  sections: ContentSection[];
}

export default function EducationalContent({ sections }: EducationalContentProps) {
  return (
    <section data-section="education" className="py-16 lg:py-24 bg-background">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl lg:text-4xl font-heading font-semibold text-foreground mb-12 text-center">
            Understanding Your Condition
          </h2>
          <div className="space-y-8">
            {sections.map((section) => (
              <div key={section.id} className="bg-card border border-border rounded-xl p-6 lg:p-8 shadow-elevation-sm">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <Icon name={section.icon as any} size={24} className="text-primary" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-heading font-semibold text-foreground mb-3">
                      {section.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      {section.content}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}